export default __webpack_public_path__ + "static/media/404.f6f356a7.png";